import { NgModule } from '@angular/core';
import { RoleService } from './shared/role.service';
import { PermissionService } from './shared/permission.service';
import { UserService } from './shared/user.service';
import { RouterModule } from '@angular/router';
import { UserDashboardComponent } from './user-dashboard.component';
import { OverviewComponent } from './overview/overview.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserComponent } from './user/user.component';
import { CarrierManagerFormComponent } from './carrier-manager-form/carrier-manager-form.component';
import { PermissionListComponent } from './permissions/permission-list.component';
import { RoleListComponent } from './roles/role-list.component';
import { RoleComponent } from './role/role.component';
import { SharedModule } from '../shared/shared.module';
import { CarrierListComponent } from './carrier-list/carrier-list.component';
import { CarrierFormComponent } from './carrier-form/carrier-form.component';
import { CarrierService } from './shared/carrier.service';
import { BlujayUrlService } from './shared/blujay-url.service';
import { BlujayService } from './shared/blujay.service';
import { DriverListComponent } from './driver-list/driver-list.component';
import { DriverComponent } from './driver/driver.component';
import { UserTableComponent } from './user-table/user-table.component';
import { UserFormComponent } from './user-form/user-form.component';
import { DriverService } from './shared/driver.service';
import { CarrierManagerService } from './shared/carrier-manager.service';
import { CarrierManagerListComponent } from './carrier-manager-list/carrier-manager-list.component';
import { OverviewService } from './shared/overview.service';
import { ChepManagerListComponent } from './chep-manager-list/chep-manager-list.component';
import { ChepManagerFormComponent } from './chep-manager-form/chep-manager-form.component';
import { AdministratorListComponent } from './administrator-list/administrator-list.component';
import { AdministratorFormComponent } from './administrator-form/administrator-form.component';
import { CarrierDriverListComponent } from './carrier-driver-list/carrier-driver-list.component';
import { UserCacheService } from './shared/user-cache.service';
import { USER_DASHBOARD_ROUTES } from './user-dashboard.routes';
import { FeatureProfileService } from './shared/feature-profile.service';
import { SubcontractorListComponent } from './subcontractor-list/subcontractor-list.component';
import { SubcontractorFormComponent } from './subcontractor-form/subcontractor-form.component';
import { SubcontractorService } from './shared/subcontractor.service';
import { SubcontractorDriverListComponent } from './subcontractor-driver-list/subcontractor-driver-list.component';
import { RegionListComponent } from './region-list/region-list.component';
import { RegionFormComponent } from './region-form/region-form.component';
import { RegionService } from './shared/region.service';
import { RegionFeaturesEditorComponent } from './region-features-editor/region-features-editor.component';
import { RegionFeatureComponent } from './region-features-editor/region-feature/region-feature.component';
import { FeatureProfileEditorComponent } from './feature-profile-editor/feature-profile-editor.component';
import { PlantManagerListComponent } from './plant-manager-list/plant-manager-list.component';
import { PlantManagerFormComponent } from './plant-manager-form/plant-manager-form.component';
import { FeatureEditorComponent } from './feature-profile-editor/feature-editor/feature-editor.component';
import { RegionFeatureNewComponent } from './region-features-editor/region-feature-new-editor/region-feature-new.component';
import { PodReviewerListComponent } from './pod-reviewer-list/pod-reviewer-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BlueChatBadgeComponent } from './shared/bluechat/bluechat-badge/blue-chat-badge.component';
import { CoreModule } from '../core/core.module';
import { OverdueManagerListComponent } from './overdue-manager-list/overdue-manager-list.component';
import { RolesLabelService } from './shared/rolesLabel.service';
import { ChepServiceRepListComponent } from './chep-service-rep-list/chep-service-rep-list.component';
import { ChepServiceRepFormComponent } from './chep-service-rep-form/chep-service-rep-form.component';
import { BlueyonderUserFormComponent } from './blueyonder-user-form/blueyonder-user-form.component';
import { BlueyonderUserListComponent } from './blueyonder-user-list/blueyonder-user-list.component';
import { SustainabilityManagerListComponent } from './sustainability-manager-list/sustainability-manager-list.component';
import { UserSearchComponent } from './user-search/user-search.component';
import { RegionFeatureStatusComponent } from './region-features-editor/region-feature-status/region-feature-status.component';

@NgModule({
    imports: [
        RouterModule.forChild(USER_DASHBOARD_ROUTES),
        ReactiveFormsModule,
        SharedModule,
        CoreModule
    ],
  declarations: [
    UserDashboardComponent,
    OverviewComponent,
    UserListComponent,
    UserComponent,
    PermissionListComponent,
    RoleListComponent,
    RoleComponent,
    CarrierListComponent,
    CarrierFormComponent,
    DriverListComponent,
    DriverComponent,
    UserTableComponent,
    UserFormComponent,
    CarrierManagerListComponent,
    CarrierManagerFormComponent,
    ChepManagerListComponent,
    ChepManagerFormComponent,
    AdministratorListComponent,
    AdministratorFormComponent,
    CarrierDriverListComponent,
    SubcontractorListComponent,
    SubcontractorFormComponent,
    SubcontractorDriverListComponent,
    RegionListComponent,
    RegionFormComponent,
    RegionFeaturesEditorComponent,
    RegionFeatureComponent,
    RegionFeatureStatusComponent,
    FeatureProfileEditorComponent,
    PlantManagerListComponent,
    PlantManagerFormComponent,
    FeatureEditorComponent,
    RegionFeatureNewComponent,
    PodReviewerListComponent,
    BlueChatBadgeComponent,
    OverdueManagerListComponent,
    BlueyonderUserFormComponent,
    BlueyonderUserListComponent,
    ChepServiceRepListComponent,
    ChepServiceRepFormComponent,
    SustainabilityManagerListComponent,
    UserSearchComponent
  ],
  providers: [
    UserService,
    PermissionService,
    BlujayUrlService,
    BlujayService,
    RoleService,
    CarrierService,
    DriverService,
    CarrierManagerService,
    OverviewService,
    UserCacheService,
    FeatureProfileService,
    SubcontractorService,
    RegionService,
    RolesLabelService
  ]
})
export class UserDashboardModule {
}
